var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{staticClass:"al-progress",attrs:{"test-id":"al-progress"}},[_c('b-progress-bar',{ref:"al-progress-bar",attrs:{"value":_vm.value,"variant":_vm.variant}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }